import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { TS_HorizontalWorkspace, TS_Workspace } from '@nu-art/ts-workspace-frontend/index';
import { Component_ExpressionBuilder } from '../../expression-builder/Component_ExpressionBuilder.js';
import { Panel_ExpressionSidePanel } from '../../expression-builder/components/expression-side-panel/Panel_ExpressionSidePanel.js';
export const WorkspaceKey_ExpressionBuilder = 'workspace-key--expression-builder';
export const WorkspaceConfig_ExpressionBuilder = {
    name: 'expression-builder',
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            {
                name: 'LeftPanel', key: 'builderPanel', visible: true, factor: 2 / 3, min: 850,
                data: {
                    filter: ''
                }
            },
            {
                name: 'RightPanel', key: 'utilsPanel', visible: true, factor: 1 / 3, min: 600,
                data: {
                    filter: '',
                }
            },
        ]
    }
};
export class ATS_ExpressionBuilder extends ComponentSync {
    static screen = {
        name: 'Expressions Builder Playground',
        key: 'expressions-builder-playground',
        renderer: this,
        group: 'Quai Dev Tools'
    };
    renderers = {
        horizontalSpace: TS_HorizontalWorkspace,
        builderPanel: Component_ExpressionBuilder,
        utilsPanel: Panel_ExpressionSidePanel
    };
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'match_parent', children: [_jsx(TS_Workspace, { workspaceKey: WorkspaceKey_ExpressionBuilder, renderers: this.renderers }), ";"] });
    }
}
//# sourceMappingURL=ATS_ExpressionBuilder.js.map